// flow weak

import React, {
    PureComponent
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import Dialog from 'material-ui/Dialog';
  import FlatButton from 'material-ui/FlatButton';
  import RaisedButton from 'material-ui/RaisedButton';
  import { Multiselect } from 'react-widgets';
  import TimePicker from 'react-times';
  import 'react-times/css/classic/default.css';
  
  
  class UpdateBuddy extends PureComponent {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = { 
        buddy_id: props.match.params.id,
        buddy_details: {
            mobile_no:'',
            name: '',
            role:0,
            department:0,
            games:[],
            is_active:false
        },
        departments_arr:[], 
        role_arr: [],
        game_types: [],
        user_search_list: [],
        temp_list_game: [],
        dialog_open_buddy:true,
        selected_game_types:[],
        search: false,
        success:false,
        message:''
      };
      this.searchUser = this.searchUser.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.handleUserSubmit = this.handleUserSubmit.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this)
      this.onSelect = this.onSelect.bind(this);
      this.onChange = this.onChange.bind(this);
      // this.handleVenueChange = this.handleVenueChange.bind(this)
    }
  
  componentDidMount() {
      this.getDetails();
      // this.getBuddy();
  }  

  getDetails(){
  const url = `${getLocationOrigin()}/buddy/get_details_for_buddy_addition`;
  const options = {...defaultOptions};

  return fetch(url, options)
     .then(checkStatus)
     .then(parseJSON)
     .then(data => {
          if(data.success){
            this.setState({success:data.success,role_arr:data.buddy_types,departments_arr:data.departments,game_types:data.game_types},()=>{this.getBuddy()})
          }
          else{
            this.setState({success:data.success,message:data.message})
            alert(data.message)
          }
         // alert("fix");
     }).catch(error => error);
  }

  getBuddy(){
    const url = `${getLocationOrigin()}/buddy/get_buddy_details/?buddy_id=${this.state.buddy_id}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            if(data.success){
              this.setState({success:data.success},()=>{this.setData(data)})
            }
            else{
              this.setState({success:data.success,message:data.message})
            }
           // alert("fix");
       }).catch(error => error);
  }

  setData(data) {
    var new_value =  Object.assign({}, this.state.buddy_details);
    new_value['name'] = data.result.name
    new_value['mobile_no'] = data.result.mobile_no
    new_value['is_active'] = data.result.is_active
    new_value['role'] = data.result.buddy_type
    new_value['department'] = data.result.department
    new_value['games'] = data.result.game_type
    var selected_game_types = this.state.game_types.filter(game => data.result.game_type.includes(game.pk))
    console.log('selected_game_types',selected_game_types)
    this.setState({buddy_details:new_value,selected_game_types:selected_game_types})
  }

  postUpdateBooking(buddy_id,details,props) {
      console.log(details)
      const url = `${getLocationOrigin()}/buddy/update_buddy/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                                        'buddy_id': buddy_id,
                                        'buddy_details': details
                                            });
      console.log('Going to fetch');
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(response=>{  
          console.log('response',response)
          alert(response.message)
          props.history.goBack();
        })
        .catch(error => {
          console.log(error);
          alert(error.message);
        });
    }

  handleChange(event) {
      const name = event.target.name;
      const target = event.target
      const value = target.type === 'checkbox' ? target.checked : target.value
      console.log(name,value)
      var new_value =  Object.assign({}, this.state.buddy_details);
      new_value[name] = value
      this.setState({buddy_details: new_value});
      // this.getAmount(this.state.equipment_details)
  }

  handleSubmit(event) {
      console.log('handle')
      event.preventDefault();
      console.log('Submit');
      this.postUpdateBooking(this.state.buddy_id,this.state.buddy_details ,this.props)
    }

  handleUserSubmit(){
    console.log('post');
      
    const url = `${getLocationOrigin()}/eagleeye/add_new_user/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'user_name': this.state.buddy_details.name,
                        'user_mobile': this.state.buddy_details.mobile_no,
                      });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .catch(error => {
        console.log(error);
        alert(error.message);
      })
      .then(data => {
        if(data.success){
          var cust = Object.assign([], this.state.buddy_details);
          cust.push({'id': data.user.id, 'name': data.user.name, 'mobile_no':data.user.mobile_no});
          this.setState({user_search_list: cust});
          alert(data.message);
          this.handleClose();
        } else {
          alert(data.message);
        }
       });
    }

    getSearchList(mobile_no) {
      const url = `${getLocationOrigin()}/eagleeye/search_user/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                           'search': mobile_no
                         });
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => this.setState({user_search_list: data.results, search: true}))
         .catch(error => {
           console.log(error);
           alert(error.message);
         });
    }

    searchUser() {
      {this.state.buddy_details.mobile_no?this.getSearchList(this.state.buddy_details.mobile_no):
        alert('Search cannot be blank')}
    }

    setSearch(name, customer_id, mobile_no){
      var new_selected_one =  Object.assign({}, this.state.buddy_details);
      new_selected_one['user_id'] = customer_id
      new_selected_one['mobile_no'] = mobile_no
      new_selected_one['name'] = name
      this.setState({buddy_details: new_selected_one, search: false});
    }

    handleClose = () => {
      this.setState({dialog_open_cust:false});
    };
    handleOpen=()=>{
      this.setState({dialog_open_cust:true})
    }

    onSelect(optionsList, selectedItem) {
        var name = optionsList.name ;
        this.state.temp_list_game.push(optionsList.pk)
        var new_value =  Object.assign({}, this.state.buddy_details);
        new_value['games'] = this.state.temp_list_game
        this.setState({ buddy_details: new_value});

    }

    onChange(dataItem,event){
      var name = event.dataItem.name
      var new_value =  Object.assign({}, this.state.buddy_details);
      new_value['games'] = dataItem.map(x => x.pk)
      this.setState({buddy_details:new_value,selected_game_types:dataItem.map(x=>x)});

    }

  
    render() {
      console.log('amount')
      console.log(this.state.buddy_details);
      console.log(this.state.game_types)

      const actions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handleClose}
        />,
        <FlatButton
          label="Submit"
          primary={true}
          onClick={this.handleUserSubmit}
        />,
      ];

      return(
        <div style={styles.container}> 

          <div className="row col-md-9 table-bordered" style={styles.table}>
            <div style={styles.main_header} className="col-md-12 label_blue_1">
              <h3 style={{textAlign:'center'}}> Update Buddy</h3>
            </div>
           
              <form  className="validated-form form-horizontal container">
              <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Buddy Name
                  </div>
                  <input style={styles.input} name="name" value={this.state.buddy_details.name}
                  onChange={this.handleChange} />
              </div>

              <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Buddy Number
                  </div>
                  <input style={styles.input} name="mobile_no" value={this.state.buddy_details.mobile_no}
                  onChange={this.handleChange} />
              </div>

              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Role
                </div>
               <select name="role" className="col-md-6" style={styles.item_body} value={this.state.buddy_details.role}
                 onChange={this.handleChange}>
                  {
                     Object.keys(this.state.role_arr).map((key,index)=>(
                       <option key={key} value={key}>{this.state.role_arr[key]}</option>
                      ))
                   }
               </select>
              </div>

              <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                  Department
                </div>
               <select name="department" className="col-md-6" style={styles.item_body} value={this.state.buddy_details.department}
                 onChange={this.handleChange}>
                  { 
                     Object.keys(this.state.departments_arr).map((key,index)=>(
                       <option key={key} value={key}>{this.state.departments_arr[key]}</option>
                      ))
                  }
               </select>
              </div>

              <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">Is active ? </div>
                  <div style={styles.item_header,{padding:'0%'}} className="col-md-6">
                  <input type='checkbox' name='is_active' onChange={this.handleChange} checked={this.state.buddy_details.is_active}/>
                  </div>
              </div>
              
              <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Game Types
                  </div>
                  <div style={styles.item_body} className="col-md-6">
                      <Multiselect
                        placeholder="Game Types"
                        data={this.state.game_types}
                        value={this.state.selected_game_types}
                        textField='name'
                        onSelect={this.onSelect} 
                        onChange={this.onChange}
                        filter='contains' 
                       />
                  </div>      

              </div>
             
              <div style={{padding:'1%', marginLeft:'10px'}}>
                <div style={styles.button_submit} className="col-md-12">
                  <input className="button1" type="submit" value="Submit" onClick={this.handleSubmit}/>
                </div>
              </div>
                
            </form>
          </div>
        </div>
      );
    }
  }
  
  export default UpdateBuddy;
  


// WEBPACK FOOTER //
// ./src/app/views/centerportal/crud/updateBuddy/UpdateBuddy.js